@if (defaultDatePeriod$ | async; as defaultDatePeriod) {
  <glxy-date-range-presets
    [dateRangeForCustomDefault]="defaultCustomDateRange$ | async"
    [defaultDatePeriod]="defaultDatePeriod"
    (selectedDateRange)="onDateChange($event)"
    (selectedDateRangePeriod)="onPeriodChange($event)"
    [comparison]="true"
    [collapseViewportWidth]="collapseViewportWidth()"
  ></glxy-date-range-presets>
}
